import React from 'react';
import createTheme from '@mui/material/styles/createTheme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';

type ChildElement = JSX.Element | '' | false | undefined;

export interface StryderThemeProps {
  children: ChildElement | ChildElement[];
}

const theme = createTheme({
  typography: { fontFamily: 'Poppins,Helvetica,Arial,sans-serif' },
  palette: {
    primary: { main: '#073050' },
    secondary: { main: '#008ed3' }
  }
});

/**
 * Theme provider for the Stryder brand.
 */
const StryderTheme = (props: StryderThemeProps) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default StryderTheme;
